import * as tslib_1 from "tslib";
import { Vue, Component, Prop, Inject } from "vue-property-decorator";
import axios from "axios";
let MutilText = class MutilText extends Vue {
    constructor() {
        super(...arguments);
        this.showAll = false;
        this.collapsed = true;
    }
    get layoutType() {
        if (this.layoutTypeFn) {
            return this.layoutTypeFn();
        }
    }
    goLink(text) {
        if (text) {
            let url = window.config.apiHost + '/xier/srm/login/getSrmLoginUrl?finalUrl=' + text;
            axios.get(url).then((res) => {
                if (res) {
                    window.open(res);
                }
            });
        }
    }
    scroll() {
        const el = this.$el;
        this.showAll = el.scrollHeight > el.offsetHeight + 3;
        // console.log('mutil-text',el.scrollHeight,el.offsetHeight);
        if (el.offsetHeight === 0) {
            clearTimeout(this.taskRef);
            this.taskRef = setTimeout(() => {
                this.scroll();
            }, 500);
        }
    }
    toggle(target) {
        this.collapsed = !this.collapsed;
        const elSpan = target.currentTarget;
        //展开时让'收起'另起一行
        if (!this.collapsed) {
            elSpan.parentNode.style.height = (elSpan.parentNode.scrollHeight + 20) + 'px';
        }
    }
    mounted() {
        this.$nextTick(() => {
            this.scroll();
        });
    }
    destroyed() {
        clearTimeout(this.taskRef);
    }
};
tslib_1.__decorate([
    Prop({
        default: ""
    })
], MutilText.prototype, "text", void 0);
tslib_1.__decorate([
    Prop({
        default: "left"
    })
], MutilText.prototype, "align", void 0);
tslib_1.__decorate([
    Prop({
        default: ''
    })
], MutilText.prototype, "labelStyle", void 0);
tslib_1.__decorate([
    Inject()
], MutilText.prototype, "layoutTypeFn", void 0);
MutilText = tslib_1.__decorate([
    Component({
        name: "mutil-text"
    })
], MutilText);
export default MutilText;
